import request from "@/utils/request";
// 个人岗位职称信息查询
export function getPersonInfo(params) {
    return request({
        url: "/jxjy/jxjyJsGw/person/info",
        method: "get",
        params,
    });
}